import { FC } from "react";

import { TruncatedText } from "@/components/_molecules/truncated-text/truncated-text";
import { cn } from "@/lib/cn";

import { Phase } from "../models/phase-model";

import { PhaseIcon } from "./phase-icon";
import { PhaseViewEmpty } from "./phase-view-empty";

interface PhaseViewProps {
  phase: Phase | null;
  logoOnly?: boolean;
  canTruncateLabel?: boolean;
  className?: string;
}

export const PhaseView: FC<PhaseViewProps> = ({ phase, canTruncateLabel = false, ...props }) => {
  if (!phase) {
    return <PhaseViewEmpty {...props} canTruncateLabel={canTruncateLabel} />;
  }

  return (
    <div className={cn(["flex flex-row items-center gap-2", canTruncateLabel && "min-w-0"])} data-testid="phase-view">
      <PhaseIcon phase={phase} className={cn(["h-4 w-4 shrink-0", props.className])} />
      {!props.logoOnly && <TruncatedText text={phase.name} canTruncate={canTruncateLabel} />}
    </div>
  );
};
